var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timeAxis',{attrs:{"marks":_vm.marks,"max":971,"intervalDate":50,"flightData":_vm.flightData},on:{"keyFn":_vm.keyFrameFn,"playpause":_vm.playpause,"redo":_vm.redo,"timeInput":_vm.timeInput,"watchValue":_vm.watchValue,"init":_vm.init}})
}
var staticRenderFns = []

export { render, staticRenderFns }